import React from "react";
import { getNotificationIcon } from "../../../../utils/images";
import "./NotificationCard.scss";
import { useNavigate } from "react-router-dom";

const NotificationCard = ({notification}) => {

  const navigate = useNavigate();

  function handleOnClick() {
    navigate(notification.url)
  }

  return (
    <div className="NotificationCard" onClick={handleOnClick}>
      <div>
        <img src={getNotificationIcon(notification.icon.split(".")[0])} />
      </div>
      <div>
        <div className="title">
          {notification.title}
        </div>
        <div className="message">
          {notification.message}
        </div>
        <div className="date">
          {notification.date}
        </div>
      </div>
    </div>
  )
}

export default NotificationCard